<script>
export default {
    name: "Approvers",

    props: {
        showModal: Boolean,
        users: {
            type: Array,
        },
        storeLocation: {
            type: Object,
            required: true,
        },
    },
}
</script>
<template>
<tail-modal :show="showModal" dimension="md:w-2/3 w-11/12">
  <template v-slot:title>
    <h5 class="font-medium text-sm">Users</h5>
  </template>
  <template v-slot:modal-body>
    <div class="w-full flex flex-wrap items-center">
        <div class="w-full overflow-auto">
            <table class="table">
                <thead class="bg-blue-500 text-white text-xs">
                    <tr class="w-full flex">
                        <th class="p-tiny flex-1">Id</th>
                        <th class="p-tiny flex-1">Name</th>
                        <th class="p-tiny flex-1">Category</th>
                    </tr>
                </thead>
                <tbody class="flex flex-col items-center overflow-auto bg-gray-100 
                    text-xs" style="max-height:50vh;">
                    <tr class="w-full flex" 
                        v-for="(storeU, idx) in users" 
                        :key="idx">
                        <td class="p-tiny flex-1">{{ storeU.userId }}</td>
                        <td class="p-tiny flex-1">{{ storeU.userName }}</td>
                        <td class="p-tiny flex-1">
                            {{ storeU.isApprover ? `Approver` : `Normal` }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
  </template>
  <template v-slot:modal-footer>
    <button class="btn-danger btn-sm text-xs rounded" 
        @click.prevent="$emit(`closeModal`)">
       <i class="fa fa-times"></i> Close</button>
  </template>
</tail-modal>
</template>